import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogContent, DialogTitle, DialogActions, TextField, Button, Typography } from '@material-ui/core';
import CancelAcceptForm from "../Common/CancelAcceptForm";
import t from "../../languages/pl";
import { themeTypeToBool } from '../../utils/helpers';

const useStyles = theme => ({
    buttonLabel: {
        color: "#FAFAFA"
    },
    button: {
        margin: theme.spacing(1)
    },
    textFieldLabel: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    },
    container: {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
    },
    textfield: {
        marginBottom: theme.spacing(1),
        display: "block"
    },
    existingGroup: {
        textAlign: "center",
        color: "red",
        fontSize: "0.875rem",
        fontWeight: "bold",
        marginBottom: theme.spacing(1),
    },

});

const AddGroup = props => {
    const { classes, groupsNames, onSubmit } = props;
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState("");
    const [exisingGroupName, setExisingGroupName] = useState(false);

    useEffect(() => {
        setExisingGroupName(groupsNames.includes(value));
    }, [value]);

    const handleSubmit = () => {
        if(onSubmit)
            onSubmit(value);
        hendleClose();
    };

    const handleKeyUp = (e) => {
        if(e.key === "Enter")
            handleSubmit();
    };

    const hendleClose = () => {
        setOpen(false);
        setValue("");
    };

    return (
        <React.Fragment>
                <Button
                    variant="contained"
                    color="primary"
                    classes={{ root: classes.button, label: classes.buttonLabel }}
                    onClick={() => setOpen(true)}
                >
                    {t.addGroup}
                </Button>

                <Dialog
                    open={open}
                    onClose={hendleClose}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle>
                        {t.addGroup}
                    </DialogTitle>
                    <DialogContent className={classes.container}>
                        <TextField
                            label={t.groupName}
                            className={classes.textfield}
                            InputLabelProps={{
                                classes: { root: classes.textFieldLabel}
                            }}
                            autoFocus
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            onKeyUp={handleKeyUp}
                            onCancel
                        />
                    </DialogContent>
                    <Typography
                        variant="body1"
                        className={classes.existingGroup}
                        style={{ display: exisingGroupName ? "block" : "none" }}
                    >
                        {t.groupWithThatNameExists}
                    </Typography>
                    <DialogActions>
                        <CancelAcceptForm
                            onCancel={hendleClose}
                            onSubmit={handleSubmit}
                            disableSubmit={exisingGroupName}
                        />
                    </DialogActions>
                </Dialog>
        </React.Fragment>
    );
};

AddGroup.propTypes = {
    classes: PropTypes.object,
    groupsNames: PropTypes.array,
    onSubmit: PropTypes.func
};

export default withStyles(useStyles)(AddGroup);
